'use client';
import dynamic from 'next/dynamic';
// Splash screen disabled per request — keep import + wrapper commented so
// it can be revived instantly. To re-enable: uncomment the import, then
// re-wrap the homepage children with <IntroSplash>...</IntroSplash> below.
// import { IntroSplash } from '@/components/IntroSplash';

// Above/near-top sections: static imports (part of initial bundle).
import { HeroTwo } from '@/components/landing/HeroTwo';
import { MetricsBand } from '@/components/primitives/MetricsBand';
import { HOMEPAGE_METRICS } from '@/content/metrics';
import { LogoMarquee } from '@/components/landing/LogoMarquee';
import { CapabilitiesHomeTwo } from '@/components/landing/CapabilitiesHomeTwo';
import i80 from './Independence80.module.css';

// Below-the-fold sections: code-split into separate client chunks via
// next/dynamic. ssr defaults to true here, so the HTML is still prerendered
// for the static export (SEO-safe) — this only splits the CLIENT bundle so the
// JS for these sections downloads/hydrates separately, reducing initial TBT.
const AIEnginesHomeTwo = dynamic(() =>
  import('@/components/landing/AIEnginesHomeTwo').then((m) => m.AIEnginesHomeTwo)
);
const Outcomes = dynamic(() =>
  import('@/components/landing/Outcomes').then((m) => m.Outcomes)
);
const Testimonials = dynamic(() =>
  import('@/components/landing/Testimonials').then((m) => m.Testimonials)
);
const IntegrationsBand = dynamic(() =>
  import('@/components/landing/IntegrationsBand').then((m) => m.IntegrationsBand)
);
const ChannelsBand = dynamic(() =>
  import('@/components/landing/ChannelsBand').then((m) => m.ChannelsBand)
);
const CtaBand = dynamic(() =>
  import('@/components/landing/CtaBand').then((m) => m.CtaBand)
);
const FAQ = dynamic(() =>
  import('@/components/landing/FAQ').then((m) => m.FAQ)
);
const BookDemoSection = dynamic(() => import('@/components/BookDemoSection'));

/**
 * Root homepage `/`.
 *
 * The previous root composition (HeroCelestial + Hero + Outcomes +
 * PlatformPipeline + AIEngines + WhyUs + …) is preserved at
 * /home-original for reference / rollback. /home-two also still
 * renders this same composition during the transition.
 *
 * NOTE: The `EmpoweringEveryUser` section (circular integrations
 * scatter) is intentionally NOT rendered here. It lives in
 * components/landing/EmpoweringEveryUser.jsx for reuse on the
 * dedicated /integrations page.
 *
 * The hero collage (5 floating product screenshots) is rendered
 * INSIDE HeroTwo via the HeroLockup `belowContent` prop, so it
 * shares the hero's bg-image and visually continues from the CTA.
 *
 * TEMPORARY — Independence campaign watercolor background wrap. Remove the
 * wrap and Independence80.module.css when the campaign ends; restore bare
 * <HeroTwo /> + <MetricsBand />.
 */
export default function Home() {
  return (
    // To bring the splash back: re-import IntroSplash above, then wrap
    // the fragment below with <IntroSplash>...</IntroSplash>.
    <>
      <div className={i80.wrap}>
        <HeroTwo className={i80.heroTransparent} />
        <MetricsBand items={HOMEPAGE_METRICS} />
      </div>
      <LogoMarquee />
      <CapabilitiesHomeTwo />
      <AIEnginesHomeTwo />
      <Outcomes />
      <Testimonials />
      <ChannelsBand />
      <IntegrationsBand />
      <CtaBand />
      <FAQ />
      <BookDemoSection />
    </>
  );
}
